<template>
    <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <el-form-item label="考勤组" prop="attendanceSection">
                <el-select v-model="ruleForm.attendanceSection" placeholder="请选择考勤组">
                    <el-option :label="item.name" :value="item.id" v-for="item in options" :key="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="text-align: center;">
                <el-button type="primary" @click="submitForm('ruleForm')">修改</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            ruleForm: {
                attendanceSection: '',
            },
            rules: {
                attendanceSection: [
                    { required: true, message: '请选择考勤组', trigger: 'change' }
                ],
            }
        }
    },
    props: ["options", "amendSubmit"],
    created() {
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // console.log(this.ruleForm.attendanceSection);
                    this.$emit("amendSubmit", this.ruleForm.attendanceSection)
                } else {
                    return false;
                }
            });
        },

    }
}
</script>

<style scoped lang="scss"></style>